import * as React from 'react';
import { Layout } from 'antd';

interface IAppFooterProps {
  style: any;
}

class AppFooter extends React.Component<IAppFooterProps> {
  render() {
    return (
      <Layout.Footer style={{ textAlign: 'center', ...this.props.style }}>
        Fox Media Czech Republic © {new Date().getFullYear()}
      </Layout.Footer>
    );
  }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/Layout/AppFooter.tsx